// Test IDs for the Product Detail Page (/p/:handle).
// See ./index.js for the recipe when adding new features.

export const PDP = {
        page: 'pdp-page',
        title: 'pdp-title',
        gallery: 'pdp-gallery',
        primaryImage: 'pdp-primary-image',
        thumbs: 'pdp-thumbs',
        thumb: 'pdp-thumb',
        buyBox: 'pdp-buy-box',
        priceCurrent: 'pdp-price-current',
        priceCompare: 'pdp-price-compare',
        inventoryChip: 'pdp-inventory-chip',
        variantAxis: 'pdp-variant-axis',
        variantOption: 'pdp-variant-option',
        buyButton: 'pdp-buy-button',
        companionCopy: 'pdp-companion-copy',
};
